<template>
  <el-button
    type="primary"
    v-if="parseImageList.length > 0"
    @click="downloadMultipleImages"
  >
    {{ buttonText }} 共{{ parseImageList.length }}张
  </el-button>
</template>

<script>
export default {
  name: "ImageDownload",
  props: {
    buttonText: {
      type: String,
      default: "下载图片",
    },
    imageList: {
      type: Array,
      default: () => [],
    },
    imageFilePrefix: {
      type: String,
      default: "",
    },
  },
  computed: {
    parseImageList() {
      let _parseImageList = [];
      this.imageList.forEach((img) => {
        img
          .split("|")
          .filter((item) => item)
          .forEach((item) => {
            _parseImageList.push(item);
          });
      });
      if (this.imageFilePrefix) {
        _parseImageList = _parseImageList.map((item, index) => {
          return {
            url: item,
            name: `${this.imageFilePrefix}_${index + 1}.${this.getUrlExt(item)}`,
          };
        });
      } else {
        _parseImageList = _parseImageList.map((item, index) => {
          return {
            url: item,
            name: `${index + 1}.${this.getUrlExt(item)}`,
          };
        });
      }
      return _parseImageList;
    },
  },
  methods: {
    getUrlExt(url) {
      // 获取url的扩展名
      return url.split(".").pop();
    },
    downloadImage(item) {
      return fetch(item.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`请求 ${item.url} 失败，状态码: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = item.name;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }, 100);
        });
    },
    downloadMultipleImages() {
      console.log("imageList:", this.parseImageList);
      console.log("开始下载...");
      return Promise.all(
        this.parseImageList.map((item) => {
          return this.downloadImage(item);
        })
      ).then(() => {
        console.log("所有图片下载完成");
      });
    },
  },
};
</script>
